<ppl-radio-group
  [value]="value"
  [hasContainerClass]="false"
  (valueChange)="onValueChange($event)">
  @for (option of options; track option.id) {
    <ppl-radio-button [value]="option.id">
      <div class="method-info-container">
        <ppl-icon
          [svgIcon]="option.icon"
          height="32px"
          width="32px"></ppl-icon>
        <div>
          <div class="method-info-name">
            @switch (option.type) {
              @case (TwoFAType.AUTH_APP) {
                <ng-container i18n="@@Authenticator_App">Authenticator App</ng-container>
              }
              @case (TwoFAType.EMAIL) {
                <ng-container i18n="@@Email_Message">Email Message</ng-container>
              }
              @case (TwoFAType.SMS) {
                <ng-container i18n="@@Text_Message_(SMS)">Text Message (SMS)</ng-container>
              }
              @case (TwoFAType.BACKUP_CODES) {
                <ng-container i18n="@@Use_Backup_Code">Use Backup Code</ng-container>
              }
              @case (TwoFAType.DUMMY) {
                Dummy (Test)
              }
            }
          </div>
          <div class="method-info-value">
            @switch (option.type) {
              @case (TwoFAType.AUTH_APP) {
                {{ option.name }}
              }
              @case (TwoFAType.EMAIL) {
                {{ option.value }}
              }
              @case (TwoFAType.SMS) {
                {{ option.value }}
              }
              @case (TwoFAType.BACKUP_CODES) {
                <ng-container i18n="@@Verify_via_pre-generated_codes">Verify via pre-generated codes</ng-container>
              }
              @case (TwoFAType.DUMMY) {
                {{ option.value }}
              }
            }
          </div>
        </div>
      </div>
    </ppl-radio-button>
  }
</ppl-radio-group>
